import { createSlice } from "@reduxjs/toolkit";
import { getPrintingList } from "../../reduxApi/admin/PrintingReduxApi";
const PrintingSlice = createSlice({
    name: "Printing",
    initialState: {
        status: "idle",
        isFiltered: false,
        Printing: [],
    },

    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },

        deletePrintingAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.Printing.findIndex(
                    (item) => item.ROWID === id
                );

                if (index !== -1) {
                    state.Printing.splice(index, 1);
                }
            });
        },

        updatePrintingAction: (state, action) => {
            const { ROWID, payload } = action.payload;
            const index = state.Printing.findIndex(
                (item) => item.ROWID === action.payload.ROWID
            );
            if (index !== -1) {
                state.Printing[index] = {
                    ...state.Printing[index],
                    ...payload
                };
            }

        },

        addPrintingAction: (state, action) => {
            state.Printing.unshift(action.payload);
        },

        clearFilters: (state) => {
            state.isFiltered = false;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getPrintingList.pending, (state) => {
                state.status = "pending";
            })

            .addCase(getPrintingList.fulfilled, (state, action) => {
                state.status = "fulfilled";
                console.log("printing  action", action)
                state.Printing = action.payload?.data
            })

            .addCase(getPrintingList.rejected, (state) => {
                state.status = "rejected";
            });
    },
});

export const {
    deletePrintingAction,
    updatePrintingAction,
    addPrintingAction,
    setFilteredStatus,
    clearFilters,
} = PrintingSlice.actions;

export default PrintingSlice.reducer;